import React, { forwardRef } from "react";

/** שדה טקסט — גובה/רדיוס כמו אשף (.fw-ref-input-*) */
const FWInput = forwardRef(function FWInput({ className = "", ...rest }, ref) {
  return (
    <input
      ref={ref}
      className={`fw-ui-input fw-ui-kit-input${className ? ` ${className}` : ""}`.trim()}
      {...rest}
    />
  );
});

export default FWInput;
